import { defineComponent as _defineComponent } from 'vue';
import {} from 'vee-validate';
import { watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ValidateState',
    props: {
        field: {}
    },
    emits: ['validate-state'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        let inputClass = '';
        let tooltipClass = '';
        watch(() => props.field.meta, (v) => {
            const validated = v.validated;
            const valid = v.valid;
            if (!validated) {
                inputClass = '';
            }
            if (validated && !valid) {
                inputClass = 'is-invalid';
                tooltipClass = 'invalid-tooltip';
            }
            if (validated && valid) {
                inputClass = '';
                tooltipClass = '';
            }
            emits('validate-state', { inputClass, tooltipClass });
        }, { deep: true });
        return (_ctx, _cache) => {
            return null;
        };
    }
});
